"use strict";

import Carousel from './classes/Carousel';
import ScrollBreakpoint from './classes/ScrollBreakpoint';

import { Fancybox } from '@fancyapps/ui/dist/fancybox/fancybox.esm';



/*
 * Scrolling breakpoints 
 */
(function() {
	const scrolledClassName = 'scrolled-view';
	const breakPoints = [
		{ 
			breakpoint: 450,
			callBack: {
				UP: (/*element*/) => {
					//document.querySelector('.site-top-bar').classList.remove('min');
					document.querySelector('body').classList.remove(scrolledClassName);
				},
				
				DOWN: (/*element*/) => {
					//document.querySelector('.site-top-bar').classList.add('min');
					document.querySelector('body').classList.add(scrolledClassName);
				}
			}
		},
	];
	
	const scrollBP = new ScrollBreakpoint(breakPoints);
	scrollBP.addBreakpoint({ 
		breakpoint: document.querySelectorAll('.fade-in'),
		callBack: {
			DOWN: function() {
				this.element.classList.add('shown');
			},
		},
	});
}());


(() => {
	Fancybox.defaults.Hash = false;
	Fancybox.bind('[data-fancybox]', {
		closeButton: false,
		
		Toolbar: {
			display: {
				left:[],
				middle:[],
				right: ["slideshow", "close"],
			},
		},
		Thumbs: {
			autoStart: true,
			Carousel: {
				fill: false,
				center: true,
			},
		},
	});
	
	const inlineHandlers = Array.from(document.querySelectorAll('.fancybox-inline'));
	inlineHandlers.forEach(handler => {
		const src = handler.dataset.src || null;
		if( src === null ) {
			return;
		}
		
		const srcEl = document.querySelector(src);
		if(! srcEl ) {
			return;
		}
		
		const element = { 
			src: srcEl.innerHTML, 
			type: "html", 
		};
		
		const fbOptions =  { 
			mainClass: 'inline-content-viewer', 
			closeButton: 'outside', 
		};
		
		handler.addEventListener('click', () => new Fancybox([ element ], fbOptions) );
	});
	
})();


/*
 * Hamburger menu 
 */
(function() {
	const handlers = Array.from( document.querySelectorAll('.primary-nav-handler') );
	const className = 'nav-panel-shown';
	
	handlers.forEach(handler => {
		handler.addEventListener('click', () => {
			document.body.classList.toggle(className);
		});
	});
	
	/*
	 * Escape key management
	 */
	document.body.addEventListener('keyup', event => {
		if( event.key !== 'Escape' ) {
			return;
		}
		if( document.body.classList.contains(className) ) {
			document.body.classList.remove(className);
		}
	});
})();



/*
 * Carousels 
 */
(function() {
	const params = {
		slideDuration: 9000,
		transitionDuration: 600,
	};
	const carousels = Array.from( document.querySelectorAll('.carousel') );
	carousels.forEach( c => new Carousel(c, params) );
})();



/*
 * Google Maps' iframe 
 * pointer-events managment
 *
 */
(function() {
	const containers = Array.from( document.querySelectorAll('.map-iframe--container') );
	containers.forEach(c => {
		const f = c.querySelector('.map-iframe--frame');
		if( f ) {
			c.addEventListener('click', () => f.style.pointerEvents = 'all');
			c.addEventListener('mouseleave', () => f.style.pointerEvents = 'none');
		}
	});
})();

